import _ from 'lodash';
import { PLATFORMS } from '../../const/app';
export function getProspectingPlatform(platform) {
    switch (platform) {
        case PLATFORMS.SALESFORCE_LIGHTNING:
            return 'salesforcelightning';
        case PLATFORMS.SALESFORCE_CLASSIC:
            return 'salesforceclassic';
        case PLATFORMS.HUBSPOT:
            return 'hubspot';
        case PLATFORMS.LINKEDIN:
            return 'linkedin';
        case PLATFORMS.LINKEDIN_SALES_NAVIGATOR:
            return 'linkedinSalesNavigator';
        case PLATFORMS.LINKEDIN_RECRUITER_LITE:
            return 'linkedinRecruiterLite';
        case PLATFORMS.LINKEDIN_RECRUITER_PRO:
            return 'linkedinRecruiterPro';
        case PLATFORMS.LINKEDIN_PUBLIC:
            return 'linkedinPublic';
        default:
            return _.startCase(platform);
    }
}
